import { render, staticRenderFns } from "./BaseCapabilities.vue?vue&type=template&id=cc143134&scoped=true"
import script from "./BaseCapabilities.vue?vue&type=script&lang=js"
export * from "./BaseCapabilities.vue?vue&type=script&lang=js"
import style0 from "./BaseCapabilities.vue?vue&type=style&index=0&id=cc143134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc143134",
  null
  
)

export default component.exports